<template>
	<div class="delete_person">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置人脸属性</h1>
		<!-- 设置名字 -->
		<h2 class="doc_main_h2">设置名字</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的名字属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int __stdcall SKFaceSetPersonName(const char* pszPersonID, const char* pszPersonName);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pszPersonID：人员ID</p>
        <p class="doc_main_p">（2）pszPersonName：人员姓名</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	返回：0：设置成功。返回其他：设置失败。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int nRet = SKFaceSetPersonName("1111","小红");</code></pre>
		<!-- 设置性别 -->
		<h2 class="doc_main_h2">设置性别</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的性别属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int __stdcall SKFaceSetPersonSex(const char* pszPersonID, int nPersonSex);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pszPersonID：人员ID</p>
        <p class="doc_main_p">（2）nPersonSex：人员性别</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	返回：0：设置成功。返回其他：设置失败。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int nRet = SKFaceSetPersonSex("1111",1);</code></pre>
		<!-- 设置生日 -->
		<h2 class="doc_main_h2">设置生日</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的生日属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int __stdcall SKFaceSetPersonBirthday(const char* pszPersonID, 
		int nBirthYear, int nBirthMonth, int nBirthDay);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）nBirthYear：人员生日-年份</p>
        <p class="doc_main_p">（2）nBirthYear：人员生日-年份</p>
        <p class="doc_main_p">（3）nBirthMonth：人员生日-月份</p>
        <p class="doc_main_p">（4）pszPersonID：人员ID</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	返回：0：设置成功。返回其他：设置失败。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int nRet = SKFaceSetPersonBirthday("1111",1992.05,12);</code></pre>
		<!-- 设置细节（其他备注信息） -->
		<h2 class="doc_main_h2">设置细节（其他备注信息）</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的细节信息属性（其他备注信息）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int __stdcall SKFaceSetPersonDetailsInfo(const char* pszPersonID, const char* pszDetailsInfo);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）deatilsInfo：人员细节信息（其他备注信息）</p>
        <p class="doc_main_p">（2）pszPersonID：人员ID</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	返回：0：设置成功。返回其他：设置失败。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int nRet = SKFaceSetPersonDetailsInfo("1111","盛开互动");</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','本地接口','设置人脸属性'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.delete_person{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/localface/setFaceAttribute.vue